import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'

interface HeroSectionProps {
  title: string
  subtitle?: string
  backgroundImage?: string
  overlay?: boolean
  compact?: boolean
  children?: React.ReactNode
}

export function HeroSection({
  title,
  subtitle,
  backgroundImage,
  overlay = true,
  compact = false,
  children,
}: HeroSectionProps) {
  return (
    <section
      className={cn(
        'relative flex items-center justify-center text-white',
        compact ? 'py-20 md:py-28' : 'py-28 md:py-40',
        !backgroundImage && 'bg-primary'
      )}
    >
      {backgroundImage && (
        <>
          <img
            src={backgroundImage}
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
            loading="eager"
          />
          {overlay && (
            <div className="absolute inset-0 bg-primary/70" />
          )}
        </>
      )}

      <div className="container-main relative z-10 text-center">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading mb-4"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto"
          >
            {subtitle}
          </motion.p>
        )}
        {children && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="mt-8"
          >
            {children}
          </motion.div>
        )}
      </div>
    </section>
  )
}
